/**
 * @author: Radim Buráň <xburan03@stud.fit.vutbr.cz>
 */

import './../AuctionDetail.css';
import {useEffect} from "react";
import { useState } from "react";

import Paper from '@mui/material/Paper';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import {IconButton} from "@mui/material";


function PicturePanel(props) {
    const [pictureURL, setPictureURL] = useState("")
    const [pictures, setPictures] = useState([])
    const [pictureIndex, setPictureIndex] = useState(0)

    useEffect(()=> {
        if (props.isLoaded) {
            setPictureURL(props.auction.previewPicture.path);
            setPictures(props.auction.pictures);
        }
    },[props.auction, props.isLoaded]);


    function movePhoto(offset) {
        const n = pictures.length;
        let index = pictureIndex + offset;
        if (index >= n) {
            index -= n;
        }
        else if (index < 0) {
            index = index + n;
        }

        setPictureIndex(index);
        setPictureURL(pictures[index].path);
    }


    return (
        <Paper elevation={6} sx={{ position: 'relative', padding: 2, width: 0.49, minWidth: 400, height: 400, boxSizing: "border-box" }}>

            <IconButton onClick={() => movePhoto(-1)} color="primary"
                        sx={{
                            position: 'absolute',
                            top: 200,
                            left: '-1%',
                            zIndex: '2'
                        }}
            >
                <ArrowBackIosNewIcon/>
            </IconButton>

            <IconButton onClick={() => movePhoto(1)}  color="primary"
                sx={{
                    position: 'absolute',
                    top: 200,
                    right: '-1%',
                    zIndex: '2'
                }}
            >
                <ArrowForwardIosIcon/>
            </IconButton>

            <img className="detail-photo" src={pictureURL} alt=""
                 style={{
                    position: 'absolute',
                    left: '50%',
                    top: '50%',
                    transform: 'translate(-50%, -50%)'
                }}
            />

        </Paper>

    );

}

export default PicturePanel;